import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var requestSchema = yup.object({
  documentId: yup.number().required(),
  patientId: yup.number().required(),
  expirationDate: yup.string().nullable(),
});

export function usePatientDocumentUpdateExpirationDateMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      const req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return http.patch(
        HTTP_ENDPOINTS.patientDocuments.updateExpirationDate(req.documentId),
        {
          patient_id: req.patientId,
          expiration_date: req.expirationDate,
        },
      );
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientDocuments.all],
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.patientDocuments.one],
        });
        options?.onSuccess?.(...args);
      },
    },
  );
}
